import { getToken } from '@shared/auth';

/**
 * Browsers use back-forward cache which stores complete page state in memory, so that when users navigate back, they get the previous state of the page without having to load it again.
 * This is a performance optimization, but in our case it causes problem when user logs out and then navigates back, because page will contain all user data from the previously stored state.
 * To avoid this, we force reload in case browser restored page from bfcache.
 */
export function disableBFCache(): void {
    window.addEventListener('unload', () => {
        // do nothing, just having unload handler might prevent some browsers from restoring the page on back navigation
    });

    window.addEventListener('pageshow', (event: PageTransitionEvent) => {
        if (event.persisted && !getToken()) {
            window.location.reload();
        }
    });
}
